import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { FormGroup } from '@angular/forms';
@Injectable({
	providedIn: 'root',
})
export class DatastoreService {

	constructor(
		private router: Router
	) {
		this.isCitizenship$ = this.citizenship.asObservable();

	}

	// new function called agentRestart
	agentRestart() {
		// clear all localstorage
		localStorage.clear();

		//clear all session storage
		sessionStorage.clear();

		//clear variables
		this.startQuestions = null;
		this.type_of_appointment = null;
		this.appointment_type = null;
		this.totalCost = null;
		this.pageContent = null;
		this.reference = null;
		this.isCitizenshipRoute = null;
		this.dateCapInitDate = null; // used to cap calendar dates one year from entered date

		// client details
		this.booker_first_name = null;
		this.booker_last_name = null;
		this.booker_email = null;
		this.booker_phone = null;
		this.lookupResponses = [];
		this.costBreakDown = null;
		this.selectedAddress = null;
		this.setService = null;
		this.setResource = null;
		this.extraDuration = 0; // obtained from questions
		this.childDob = false;
		this.bookingQuestions = [];
		this.unselectedLocations = [];
		this.bookingForm = null;
		this.companyAnswers = null;
		this.selectedDate = null;
		this.selectedSlot = null;
		this.selectedResource = null;
		this.selectedService = null; //used only to store the service incase we switch to the alt one
		this.selectedDepartment = null; //used only to store the service incase we switch to the alt one
		this.locations = [];
		this.bookingAnswers = null;

		if (this.isCitizenshipRoute) {
			this.router.navigate(['/start/citizenship']);
			return;
		} else {
			this.router.navigate(['/agent']);
			return;
		}
	}

	startQuestions: any;
	type_of_appointment: any;
	appointment_type: any;
	public totalCost: any;
	public pageContent: any;

	public firstSlotAnalytic: any;
	public firstSlotAnalyticKey: string;

	public reference: any;
	public isCitizenshipRoute: any;
	public dateCapInitDate: any; // used to cap calendar dates one year from entered date

	public serviceQuestionSchema: Record<string, any>;
	public selectedSchema: string;
	companyQuestionsForm: FormGroup = new FormGroup({});

	// client details
	public booker_first_name: any;
	public booker_last_name: any;
	public booker_email: any;
	public booker_phone: any;
	public lookupResponses: any[] = [];
	public costBreakDown: any;
	public selectedAddress: any;

	public setService: any;
	public setResource: any;
	public staff_set: any;
	public autoSelectedStaff: any;

	public extraDuration = 0; // obtained from questions

	public childDob: any = false;

	public bookingQuestions = [];

	public unselectedLocations = [];

	public _extraItems = [];

	public bookingForm;
	public companyAnswers;

	public selectedDate;

	public selectedSlot;

	public selectedResource;

	public selectedService; //used only to store the service incase we switch to the alt one
	public selectedDepartment; //used only to store the service incase we switch to the alt one

	public locations = [];

	public bookingAnswers;

	public customerDetailsForm;

	public client;

	public clientCreated = false;

	public address;

	public latitude;

	public longitude;

	public endSlot;

	public customerQuestions;

	public companyQuestions;

	public address1;

	public selectedLocation;

	public booking;

	public totalPrice;

	public adminJourney = false;

	public adminAuthToken = '';

	public purchase: any;

	public serviceBookingType: any;

	public selectedSuggestion: any;

	public config: any;

	public serviceFees: any;

	public ceremonyDate: any;

	public deathDate: any;

	public mccdRegDate: any;

	public journeyRoute: string;

	public skipLocationsPage = false;

	public postageCounts: any;

	public citizenshipFees = {
		'mon_fri_9_5': {
			'individual': "ef5e4e1e-d9bf-4fff-8937-d8c876b92c8f",
			'family': "65b5ac79-f3e3-4379-ae66-d83ac655f838",
		},
		'mon_fri_after_5': {
			'individual': "712c0774-5317-496f-aa4c-0aa8a379c94e",
			'family': "1935091b-9af1-4828-b97e-e8726e5c13d1"
		},
		'sat': {
			'individual': "c08c96bb-743c-44ac-a247-b7055e036b46",
			'family': "22d4d538-21cc-42dd-b2ba-fd155346c1bd"
		},
		'sun': {
			'individual': "b3026fc2-ce00-4c6f-aa60-4de0209eb248",
			'family': "00c6973f-17f2-4e7c-b77f-ae2bb02c5bb1"
		}
	};
	public citizenshipGroupFees = {
		'mon_fri_9_5': {
			'individual': "8ffb41c9-d118-4041-92c4-694996003e92",
			'family': "7426a13c-8866-42f0-b1bd-47615d44e358",
		},
		'mon_fri_after_5': {
			'individual': "04536f2b-2725-4395-95c0-76ffd78e14cb",
			'family': "a39d7dd1-1fcf-4983-afdc-ce48c356c371"
		},
		'sat': {
			'individual': "81c1645f-917e-446d-8405-961dc2245fa8",
			'family': "5d911b0a-ac26-4c71-be20-ca6ecb604b36"
		},
		'sun': {
			'individual': "4b23adc5-b640-4eab-a85d-cca2371713a5",
			'family': "f7387aea-3e19-4a3c-aecb-5cecf668172f"
		}
	};
	public citizenshipKey = '';

	public familyCitizenshipBooking = false;

	public groupCitizenshipBooking = false;

	public citizenshipExtraItem;

	notify: Subject<boolean> = new Subject<boolean>();
	onNotify(event) {
		this.notify.next(true);
	}

	private addFeesSubject = new BehaviorSubject<any>(null);
	addFees$ = this.addFeesSubject.asObservable();
	triggerAddFees(fees: any) {
		this.addFeesSubject.next(fees);
	}

	public citizenship: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isCitizenship$: Observable<boolean>;
	updateCitizenship(val: boolean) {
		this.citizenship.next(val);
	}

	public certificateStore: any;

	public applicationStore:
		| {
			formData: Record<string, string> | undefined;
			applicationType: string;
			formId: string;
			applicationNumber: string | undefined;
		}
		| undefined;
}
